"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAssetRequestToJSON = exports.SurveyAssetRequestFromJSONTyped = exports.SurveyAssetRequestFromJSON = exports.instanceOfSurveyAssetRequest = exports.SurveyAssetRequestTypeEnum = void 0;
var runtime_1 = require("../runtime");
var SurveyQuestion_1 = require("./SurveyQuestion");
var SurveyTransparencyContent_1 = require("./SurveyTransparencyContent");
/**
 * @export
 */
exports.SurveyAssetRequestTypeEnum = {
    SurveyAsset: 'SURVEY_ASSET',
    LinkedAsset: 'LINKED_ASSET'
};
/**
 * Check if a given object implements the SurveyAssetRequest interface.
 */
function instanceOfSurveyAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfSurveyAssetRequest = instanceOfSurveyAssetRequest;
function SurveyAssetRequestFromJSON(json) {
    return SurveyAssetRequestFromJSONTyped(json, false);
}
exports.SurveyAssetRequestFromJSON = SurveyAssetRequestFromJSON;
function SurveyAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'surveyTransparencyContent': !(0, runtime_1.exists)(json, 'survey_transparency_content') ? undefined : (0, SurveyTransparencyContent_1.SurveyTransparencyContentFromJSON)(json['survey_transparency_content']),
        'questions': !(0, runtime_1.exists)(json, 'questions') ? undefined : (json['questions'].map(SurveyQuestion_1.SurveyQuestionFromJSON)),
    };
}
exports.SurveyAssetRequestFromJSONTyped = SurveyAssetRequestFromJSONTyped;
function SurveyAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'survey_transparency_content': (0, SurveyTransparencyContent_1.SurveyTransparencyContentToJSON)(value.surveyTransparencyContent),
        'questions': value.questions === undefined ? undefined : (value.questions.map(SurveyQuestion_1.SurveyQuestionToJSON)),
    };
}
exports.SurveyAssetRequestToJSON = SurveyAssetRequestToJSON;
